import React, { useState, useEffect, useContext } from 'react';
import { observer } from "mobx-react"
import Draggable from "react-draggable";
import * as net from "../../lib/net";

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <div {...props} />
    </Draggable>
  );
}

function LoginDlg(props) {
    const [state, setState] = useState({ user : {} });

    function dologin(uid, pwd) {
        //this.setState({login: false });
        //this.props.history.push("cas");
        login_srv(uid, pwd);
    }
    function login_srv(uid, pwd) {
        var self = this;
		var prm = {};
		prm.uid = uid;
		prm.pwd = pwd;
		prm.token = "";

        //gda.wndLoading("Hämtar");
        net.gcs_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret));

            var o = {};
            //o.deps = ret.rco;
            //alert(JSON.stringify(o));
            //self.setState({tra: ret.rca });
            //toastr.success("OK", "SAPI");
            if(ret.ok != "000") {
                alert(JSON.stringify(ret));
                return;
            }

            var seo = ret.seo;
            //alert(JSON.stringify(seo));
            var xdo = JSON.stringify(seo);
            sessionStorage.setItem("svp", xdo);
		    props.ctx.setState({ login: false });
		    //props.ctx.props.history.push("cas");
            var url = seo.auto;
            if(url == "casino.ov") url = "cas.ov";
            url = "/" + url.replace(/\./g,"/");
            url = "http://my.svepos.com" + url;

            //alert(url);
		    props.ctx.props.navigate(url);
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
            alert(JSON.stringify(e));
            //gda.wndError(txt);
        });
    }
    function handleLogin(event) {
        //this.setState({value: event.target.value});
        //const body = new FormData(this.form);
        //alert('FORM: ' + JSON.stringify(state));
        //props.ctx.dologin(state.user.uid, state.user.pwd);
        dologin(state.user.uid, state.user.pwd);
    }
    function handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = state.user;
      user[name] = value;
      setState({user: user});
      //setState({[name]: value});
    }
	const handleClose = () => {
		props.ctx.setState({ login: false });
	};
    if(!props.show) return "";

	var html =
        <div className="mx_base">
        { props.backdrop ? <div className="mx_backdrop" /> : null }
        <div className="mx_dlg flex-col">
        <div className="mx_title">
            {"Sverigekassan Login"}
        </div>
        <div className="mx_content flex">
            <div className="flex-col flex-vcenter">
                <form>
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Användarnamn</label>
                        <input type="email" className="form-control" name="uid" value={state.uid} onChange={(event) => handleUserInput(event)} aria-describedby="emailHelp" />
                            <small id="emailHelp" className="form-text text-muted">
                                Epost eller användarnamn.
                            </small>
                    </div>
                    <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Lösenord</label>
                        <input type="password" className="form-control" name="pwd" value={state.pwd} onChange={(event) => handleUserInput(event)} />
                    </div>
                    <div className="form-group form-check">
                        <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                            <label className="form-check-label" htmlFor="exampleCheck1">Kom ihåg mig</label>
                    </div>
                </form>
            </div>
        </div>
        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w150 ripple" onClick={() => handleClose() } aria-label="System" >
                STÄNG
            </button>
            <button className="btn btn-hw-green w150 ripple" onClick={(event) => handleLogin(event) } aria-label="System" >
                LOGGA IN
            </button>
        </div>
      </div>
    </div>
	;
	return html;
}

export default LoginDlg;